import React, { useContext } from 'react'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import CreationToolError from '../../../types/error'
import { validateSourceByOutput } from '../../../utils/validate-source'
import { CreationToolUploadContext } from '../manager'
import Bulk from './bulk'
import Item from './item'

const TRANSPARENT_PIXEL =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

type Props = {
    setIsProcessing?: (isProcessing: boolean) => void
}

const CreationUploadList = ({ setIsProcessing }: Props) => {
    const { uploadSources, updateUploadSource } = useContext(CreationToolUploadContext)

    // validate upload sources
    useAsyncEffect(async () => {
        if (uploadSources.length === 1) return

        setIsProcessing && setIsProcessing(true)
        for (let i = 0; i < uploadSources.length; i++) {
            const uploadSource = uploadSources[i]
            const { source: src, outputType } = uploadSource

            try {
                const validatedSource = await validateSourceByOutput(src.source, outputType)
                updateUploadSource({ ...uploadSource, source: validatedSource })
            } catch (e) {
                const isFile = typeof uploadSource.source !== 'string'
                const error = e as CreationToolError

                // if the error is a file too long and this is bulk upload,
                // we don't want to try creating a preview blob of a huge file.
                if (
                    isFile &&
                    (error === CreationToolError.VideoTooLong || error === CreationToolError.FileSizeTooLarge)
                ) {
                    const updateSourceFile = { ...src, source: TRANSPARENT_PIXEL }
                    updateUploadSource({ ...uploadSource, source: updateSourceFile, error })
                } else {
                    updateUploadSource({ ...uploadSource, error })
                }
            }
        }
        setIsProcessing && setIsProcessing(false)
    }, [])

    return uploadSources.length === 1 ? <Item source={uploadSources[0]} /> : <Bulk />
}

export default CreationUploadList
